// src/pages/CourseTime/styles/sidebar.styles.js
import styled from 'styled-components';

export const Sidebar = styled.div`
  width: ${props => props.collapsed ? '60px' : '380px'};
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #eaeaea;
  z-index: 10;
  ${props => props.disabled && `
    pointer-events: none;
    opacity: 0.6;
  `};
  @media (max-width: 1024px) {
    height: ${props => props.collapsed ? '10px' : '100%'};
    width: ${props => props.collapsed ? '10px' : '300px'};
  }
  @media (max-width: 768px) {
    position: fixed; 
    top: 64px;
    left: 0;
    height: 100%;
    width: ${props => props.collapsed ? '0' : '100%'};
    transform: ${props => props.collapsed ? 'translateX(-100%)' : 'translateX(0)'};
    transition: transform 0.3s ease;
    border-right: 1px solid #eaeaea;
  }
`;

export const SidebarLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px;
`;

export const ProgramContainer = styled.div`
  padding: 12px 8px;
  font-family: "Source Sans Pro", "Helvetica Neue";
`;

export const Program = styled.div`
  margin-bottom: 12px;
  border-radius: 6px;
  overflow: hidden;
`;

export const ProgramHeader = styled.div`
  padding: 14px 16px;
  background-color: #f5f7fa;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-family: "Source Sans Pro", "Helvetica Neue";
  border-left: 3px solid transparent;
  ${props => props.completed && `
    border-left-color: #48bb78 !important;
    background-color: #f0fff4 !important;
  `}
  
  &:hover {
    background-color: #edf2f7;
  }
`;

export const CourseTitle = styled.div`
  font-weight: 600;
  font-size: 30px;
  color: ${({ themeColor }) => themeColor || '#32BAF1'};
  font-family: "Source Sans Pro", "Helvetica Neue";
  display: ${props => props.collapsed ? 'none' : 'block'};

  /* Mobile */
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const ProgramTitle = styled.div`
  font-weight: 600;
  font-size: 19px;
  color: #018fa6;
  font-family: "Source Sans Pro", "Helvetica Neue";
`;

export const ProgramToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ themeColor }) => themeColor || '#718096'};
  font-size: 12px;
`;

export const Units = styled.div`
  margin: 6px 0 6px 12px;
`;

export const Unit = styled.div`
  margin-bottom: 6px;
  border-radius: 5px;
  overflow: hidden;
`;

export const UnitHeader = styled.div`
  padding: 12px 16px;
  background-color: #f5f7fa;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  ${props => props.completed && `
    border-left-color: #48bb78 !important;
    background-color: #f0fff4 !important;
  `}
  
  &:hover {
    background-color: #edf2f7;
  }
`;

export const UnitTitle = styled.div`
  font-size: 18px;
  font-weight: 450;
  color: #018fa6;
`;

export const UnitToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #718096;
  font-size: 10px;
`;

export const SessionToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #718096;
  font-size: 10px;
`;

export const SessionMenu = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 6px 0 0 0;
`;

export const SessionMenuItem = styled.li`
  padding: 10px 16px 10px 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 4px;
  margin: 4px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-left: 3px solid transparent;
  
  ${props => props.active && `
    background-color: ${props.themeColor ? `${props.themeColor}15` : '#ebf8ff'} !important;
    color: ${props.themeColor || '#3182ce'} !important;
    font-weight: 500;
    border-left-color: ${props.themeColor || '#4299e1'} !important;
  `}
  
  ${props => props.completed && `
    color: #2f855a;
    background-color: #f0fff4;
    border-left-color: #48bb78 !important;
  `}
  
  &:hover {
    background-color: #edf2f7;
  }
`;

export const SessionTitleText = styled.span`
  flex: 1;
  font-size: 18px;
  font-weight: 500;
  color: ${({ themeColor }) => themeColor || '#EE6D29'};
`;

export const SegmentTitleText = styled.span`
  flex: 1;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
  color: #000;
`;

export const CompletedIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ccc;
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  
  &.completed {
    background-color: #40B93C;
  }
`;
